const RESERVED_KEYS = new Set([
  'registration_id', 'graduate_name', 'graduate_email', 'university_slug',
  'university_id', 'ceremony_id', 'ceremony_label', 'ceremony_datetime',
])

export function suggestQuestionKey(title) {
  return String(title || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^[_0-9]+|_+$/g, '').slice(0, 64).replace(/_+$/g, '')
}

export function questionKeyError(key) {
  if (typeof key !== 'string' || !/^[a-z][a-z0-9_]{0,63}$/.test(key)) return 'Use 1–64 lowercase letters, digits or underscores, starting with a letter.'
  if (RESERVED_KEYS.has(key)) return 'This key is reserved for registration information.'
  return ''
}
